const options = {
  5: "bg-fuchsia-400/5",
  10: "bg-fuchsia-400/10",
  25: "bg-fuchsia-400/25",
  50: "bg-fuchsia-400/50",
  75: "bg-fuchsia-400/75",
  90: "bg-fuchsia-400/90",
  100: "bg-fuchsia-400",
};

const from = {
  5: "from-fuchsia-400/5",
  10: "from-fuchsia-400/10",
  25: "from-fuchsia-400/25",
  50: "from-fuchsia-400/50",
  75: "from-fuchsia-400/75",
  90: "from-fuchsia-400/90",
  100: "from-fuchsia-400",
};

export default function getBackgroundFuchsia400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
